import { useEffect, useState } from 'react';

/**
 * Hook to detect if the viewport is in mobile mode (< 1024px)
 * This matches the Tailwind 'lg' breakpoint used in the layout
 */
export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
};
